import { useJobs } from '../../api/queries';
import { ErrorAlert } from '../../components/ErrorAlert';
import { JobsTable } from '../../components/JobsTable';
import { SkeletonTable } from '../../components/Skeleton';

export function TargetJobsTab({ targetId }: { targetId: string }) {
  const q = useJobs({ target: targetId, limit: 50 });
  if (q.isPending) return <SkeletonTable rows={3} />;
  if (q.isError) return <ErrorAlert error={q.error} onRetry={() => void q.refetch()} />;
  return <JobsTable jobs={q.data} variant="card" showProject={false} emptyText="Deployments and operations on this target appear here." />;
}
